var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"weighing-steps"},[_c('li',{staticClass:"weighing-steps__step"},[_vm._v(_vm._s(_vm.texts.STEP_TARE))]),_c('li',{staticClass:"weighing-steps__step"},[_vm._v(_vm._s(_vm.weighingStep))]),_c('li',{staticClass:"weighing-steps__step"},[_vm._v(_vm._s(_vm.texts.STEP_WRITE))])])
}
var staticRenderFns = []

export { render, staticRenderFns }